// JSON REGISTRY
export interface FileEntry {
    id: number;
    name: string;
    sid: string;
    description: string;
    version: string;
    database: string;
    type: string;
    blob_uri: string;
  }


  export enum eLinkTarget {
    self = '_self',
    blank = '_blank',
    parent = 'parent',
  }
  
  export enum eElementOnMouseOverEffect {
    always = 'always',
    hover = 'hover',
    none = 'none',
  }

  export enum eColors {
    paletteGreen = '#4fa500',
    paletteYellow = '#dba507',
    paletteRed = '#D50000',
    // const palettelightBlue = '#8ec7d2'
    // const paletteBlue = '#0d6986'
    // const paletteDarkBlue = '#07485b'
    paletteGray = '#fafafa',
    paletteGray2 = '#cacaca',
    paletteGray3 = '#d9d9d9',
    paletteBlack = '#121212',
    paletteBorderBlack = '#414141',
  }

  export enum eTypographyVariant {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6',
    subtitle1 = 'subtitle1',
    subtitle2 = 'subtitle2',
    body1 = 'body1',
    body2 = 'body2',
    caption = 'caption',
    overline = 'overline',
    inherit = 'inherit',
  }

  export enum eButtonSize {
    small = 'small',
    medium = 'medium',
    large = 'large',
  }

  export enum eButtonVariant {
    outlined = 'outlined',
    contained = 'contained',
    text = 'text',
  }

  export enum eButtonTypes {
    reset = 'reset',
    button = 'button',
    submit = 'submit',
  }

  export enum eColor {
    primary = 'primary',
    secondary = 'secondary',
    error = 'error',
    info = 'info',
    success = 'success',
    warning = 'warning',
  }